import classNames from 'classnames';
import Input, { InputProps } from 'components/molecules/Input';
import { Configs } from 'utils/constants';
import MoreOptionsDropDown from 'components/molecules/MoreOptionsDropDown';
import Button from 'components/atoms/Button';
import { useGetTextReplacers } from 'utils/reduxHook';
import { PopoverPlacement } from '@idui/react-popover';
import ShortenUrlButton from '../ShortenUrlButton';

export interface InputI18nProps extends InputProps {
  onAddUserData?: (replacer: string) => any;
  onShortenUrl?: (fullText: string) => any;
}

function InputI18n({
  className,
  onAddUserData,
  onShortenUrl,
  displayMessageCredits = false,
  ...rest
}: InputProps & InputI18nProps) {
  const textReplacerArr = useGetTextReplacers();

  const handleAddUserData = (replacer: string) => {
    let replacerText = '';
    if (!/\s+$/.test(rest?.value as string)) {
      replacerText = ` ${replacer}`;
    } else {
      replacerText = replacer;
    }
    onAddUserData(replacerText);
  };

  return (
    <Input
      isMultiLine
      placeholder="Write your message..."
      characterLimit={Configs.Sms.CharCount8}
      displayMessageCredits={displayMessageCredits}
      emojiCharacterLimit={Configs.Sms.EmojiCharCount8}
      {...rest}
      extraContent={
        onAddUserData || onShortenUrl ? (
          <div className="flex flex-row items-center justify-end text-right w-full py-1">
            {onShortenUrl ? <ShortenUrlButton value={rest.value} onShortenUrl={onShortenUrl} /> : null}
            {onAddUserData ? (
              <MoreOptionsDropDown
                width={200}
                buttons={textReplacerArr.map(({ text, replacer }) => ({
                  text,
                  dataDurableId: 'userDataOptionButton',
                  size: 'small',
                  className: 'text-xs',
                  onClick: () => handleAddUserData(replacer),
                }))}
                placement={PopoverPlacement.top}
                className="ml-4"
                content={
                  <Button
                    className="text-glooMedGray text-sm font-bold"
                    data-analytics="input-insert-data"
                    type="transparent"
                    size="small"
                    dataDurableId="insertDataButton"
                    icon="arrow-up"
                    iconPosition="left"
                    iconSize={14}
                    text="Insert Data"
                  />
                }
              />
            ) : null}
          </div>
        ) : null
      }
      className={classNames('min-h-[100px]', className)}
    />
  );
}

export default InputI18n;
